module.exports = __webpack_public_path__ + "img/qggl.c3b87598.png";